<div class="grid grid-nogutter w-full h-screen reset-container relative overflow-hidden m-0"
  [class.rtl]="languageService.currentLanguage() === 'ar'">

  <div class="hidden md:flex col-12 md:col-6 relative overflow-hidden bg-no-repeat bg-cover p-0 hero-pane"
    style="background-image: url('assets/images/loadgate-dark-hero.png'); background-position: center;">
    <div class="absolute top-0 left-0 w-full h-full bg-black-alpha-50 z-0"></div>

    <div class="absolute top-0 left-0 p-5 z-1">
      <div class="flex align-items-center gap-2">
        <img src="assets/images/loadgate-new-logo.png" alt="LoadGate" class="block w-auto hero-logo" />
        <span class="text-3xl font-bold text-white tracking-widest">LoadGate</span>
      </div>
    </div>

    <div class="absolute bottom-0 left-0 w-full p-6 z-1 mb-4">
      <h1 class="text-4xl text-white font-bold mb-2">{{ 'FORGOT_PASSWORD.HERO' | translate }}</h1>
      <p class="text-white-alpha-80 text-lg line-height-3 m-0">
        {{ 'FORGOT_PASSWORD.HERO_COPY' | translate }}
      </p>
    </div>
  </div>

  <div
    class="col-12 md:col-6 flex flex-column justify-content-center px-4 py-4 md:p-6 bg-gray-900 text-white relative h-full overflow-y-auto no-scrollbar">
    <div class="w-full mx-auto reset-card" style="max-width: 460px;">
      <div class="mb-4">
        <p class="eyebrow">{{ 'FORGOT_PASSWORD.BADGE' | translate }}</p>
        <h2 class="text-3xl font-semibold text-white mb-1">{{ 'FORGOT_PASSWORD.TITLE' | translate }}</h2>
        <p class="text-gray-400 text-sm line-height-3">{{ 'FORGOT_PASSWORD.SUBTITLE' | translate }}</p>
      </div>

      @if (errorMessage) {
      <div class="bg-red-900 border-1 border-red-700 text-red-100 p-3 border-round mb-4 text-sm flex align-items-start gap-2">
        <i class="pi pi-exclamation-circle mt-1"></i>
        <span>{{ errorMessage | translate }}</span>
      </div>
      }

      @if (successMessage) {
      <div class="bg-green-900 border-1 border-green-700 text-green-100 p-3 border-round mb-4 text-sm flex align-items-start gap-2">
        <i class="pi pi-check-circle mt-1"></i>
        <span>{{ successMessage | translate }}</span>
      </div>
      }

      <form [formGroup]="form" (ngSubmit)="sendResetEmail()" class="flex flex-column gap-4" novalidate>
        <span class="p-float-label">
          <input pInputText id="email" type="email" formControlName="email" class="w-full reset-input"
            [class.ng-invalid]="form.get('email')?.invalid && form.get('email')?.touched" />
          <label for="email">{{ 'FORGOT_PASSWORD.EMAIL' | translate }}</label>
        </span>

        @if (form.get('email')?.touched && form.get('email')?.invalid) {
        <small class="text-red-400 -mt-3 block">{{ 'FORGOT_PASSWORD.INVALID_EMAIL' | translate }}</small>
        }

        <button pButton pRipple type="submit" [label]="'FORGOT_PASSWORD.BUTTON' | translate"
          class="w-full font-bold custom-btn-primary p-3" [loading]="loading"></button>
      </form>

      <div class="flex justify-content-between align-items-center gap-3 mt-4">
        <a (click)="goToLogin()"
          class="text-sm font-medium text-purple-400 cursor-pointer hover:text-purple-300 transition-colors">{{
          'FORGOT_PASSWORD.BACK_TO_LOGIN' | translate }}</a>
        <span class="text-gray-500 text-xs">{{ 'FORGOT_PASSWORD.FOOTER' | translate }}</span>
      </div>
    </div>
  </div>
</div>
